var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E9CC0B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 15,
    cy: 15,
    r: 8.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 1.2,
    className: "st0",
    width: 1.8,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 25.1,
    className: "st0",
    width: 1.8,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.1,
    y: 14.1,
    className: "st0",
    width: 3.7,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.2,
    y: 14.1,
    className: "st0",
    width: 3.7,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.6,
    y: 21.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -9.684 23.4782)",
    className: "st0",
    width: 1.8,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 4.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -2.7422 6.5213)",
    className: "st0",
    width: 1.8,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.7,
    y: 22.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -14.6916 11.5289)",
    className: "st0",
    width: 3.7,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.6,
    y: 5.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 2.2655 18.4709)",
    className: "st0",
    width: 3.7,
    height: 1.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunIcon);
export default __webpack_public_path__ + "static/media/sun_icon.ba7a7dd924ae72d2e363c3fa5f46b83d.svg";
export { ForwardRef as ReactComponent };